<script lang="ts">
    import { cx } from '$lib/utils/cx';
    import { createDialog, melt } from '@melt-ui/svelte';
    import { overlayIn, overlayOut, modalIn, modalOut } from '$components/Modal.svelte';
    import * as t from '$trans';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();

    export let label: string;
    export let title: string;
    export let icon: string | null = null;
    export let iconUrl: string | null = null;

    const {
        elements: { trigger, content, portalled, overlay, close },
        states: { open },
    } = createDialog({
        defaultOpen: false,
    });
</script>

<button
    use:melt={$trigger}
    class={cx(
        'btn-reset outline-0 text-left',
        'hover:bg-brand-blue/50 focus:bg-brand-blue/50 focus:ring focus:ring-inset',
        'px-[16px] py-[12px]',
        'text-18/[120%] text-white font-medium',
        'no-underline',
        'flex justify-center items-center',
    )}
>
    {#if iconUrl != null}
        <img
            class="size-[38px] object-contain mr-[8px]"
            src={iconUrl}
            alt={label ?? ''}
        />
    {/if}
    {#if icon != null}
        <div
            class="size-[38px] shrink-0 bg-brand-blue text-white rounded-full flex items-center justify-center mr-[8px]"
        >
            <i class={cx(icon, 'text-24')} aria-hidden={true} />
        </div>
    {/if}
    <span class="flex-auto">{label}</span>
    <i class="tnp tnp-chevron-right" aria-hidden={true} />
</button>

<div use:melt={$portalled} class="relative z-modal">
    {#if $open}
        <div
            use:melt={$overlay}
            class={'fixed inset-0 bg-black bg-opacity-60'}
            in:overlayIn
            out:overlayOut
        />
        <div class="fixed inset-0 top-[60px] overflow-y-auto overscroll-contain">
            <div class={'flex h-full items-center justify-center text-center z-modal'}>
                <div
                    use:melt={$content}
                    in:modalIn
                    out:modalOut
                    class={cx(
                        'h-full w-full overflow-y-scroll bg-brand-navbar-blue-alt p-[24px]',
                    )}
                >
                    <div class="relative flex items-center mb-[24px]">
                        <div class="flex-1 flex items-start">
                            <button
                                class={cx(
                                    'btn-reset',
                                    'size-[32px]',
                                    'bg-brand-blue hover:opacity-80',
                                    'rounded-[4px]',
                                    'outline-none focus:ring',
                                )}
                                use:melt={$close}
                                aria-label={t.ui.close({}, $lang)}
                                ><i
                                    class="tnp tnp-chevron-left text-white"
                                    aria-hidden={true}
                                />
                            </button>
                        </div>
                        <div class="text-center text-white text-18/[120%] font-bold">
                            {title}
                        </div>
                        <div class="flex-1"></div>
                    </div>

                    <slot />
                </div>
            </div>
        </div>
    {/if}
</div>
